import React from 'react'
import classes from "./Sixth.module.scss"
import img1 from "../../../assets/img/MainPage/6/1.jpg"

const Sixth = () => {
    return (
        <div className={[classes.fourth, ""].join(" ")}>
            <img src={img1} alt="" />
        </div>

    )
}

export default Sixth